/* Progressive discovery. Only product handles are stored; prices stay server-owned. */
(function () {
  'use strict';
  var d = document, TGS = window.TGS || {}, root = (TGS.routes && TGS.routes.root) || '/';
  var savedKey = 'tgs:saved:v1', recentKey = 'tgs:recent:v1', memory = {}, returnFocus;
  function all(s, scope) { return Array.prototype.slice.call((scope || d).querySelectorAll(s)); }
  function valid(h) { return typeof h === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(h); }
  function read(key) {
    if (Object.prototype.hasOwnProperty.call(memory, key)) return memory[key];
    try { var list = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(list) ? list.filter(valid).slice(0, 24) : []; }
    catch (e) { return memory[key] || []; }
  }
  function write(key, list) {
    memory[key] = list;
    try { localStorage.setItem(key, JSON.stringify(list)); return true; }
    catch (e) { return false; }
  }
  function node(tag, cls, text) { var el = d.createElement(tag); if (cls) el.className = cls; if (text) el.textContent = text; return el; }
  function announce(text) { if (TGS.toast) TGS.toast(text); }
  function sync() {
    var saved = read(savedKey);
    all('[data-save-toy]').forEach(function (b) {
      var on = saved.indexOf(b.dataset.saveToy) !== -1;
      b.setAttribute('aria-pressed', String(on));
      var label = b.querySelector('[data-save-label]'); if (label) label.textContent = on ? 'Saved' : 'Save';
    });
    all('[data-saved-count]').forEach(function (el) { el.textContent = ' (' + saved.length + ')'; });
  }
  function open(dialog) {
    if (!dialog || typeof dialog.showModal !== 'function') return;
    returnFocus = d.activeElement; dialog.showModal(); d.body.classList.add('toy-dialog-open');
  }
  all('.toy-dialog').forEach(function (dialog) {
    dialog.addEventListener('close', function () { d.body.classList.remove('toy-dialog-open'); if (returnFocus && returnFocus.isConnected) returnFocus.focus(); });
    dialog.addEventListener('click', function (e) { if (e.target.closest('[data-dialog-close]')) dialog.close(); });
  });
  function fetchProduct(handle) {
    var ctrl = new AbortController(), timer = setTimeout(function () { ctrl.abort(); }, 8000);
    return fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { signal: ctrl.signal, headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('unavailable'); return r.json(); })
      .then(function (p) { clearTimeout(timer); if (!p || !p.title || !valid(p.handle)) throw new Error('product'); return p; }, function (e) { clearTimeout(timer); throw e; });
  }
  function card(p, removable) {
    var article = node('article', 'memory-card'), link = node('a', 'memory-card__link');
    link.href = root + 'products/' + encodeURIComponent(p.handle);
    if (p.featured_image) {
      var img = node('img'); var url = new URL(p.featured_image, location.origin);
      if (url.protocol === 'https:' || url.protocol === 'http:') { url.searchParams.set('width', '400'); img.src = url.href; }
      img.alt = ''; img.width = 400; img.height = 400; img.loading = 'lazy'; link.appendChild(img);
    }
    link.appendChild(node('h3', 'h4', p.title)); article.appendChild(link);
    article.appendChild(node('p', 'memory-card__price', (p.price_varies ? 'From ' : '') + (TGS.money ? TGS.money(p.price) : p.price / 100)));
    if (!p.available) article.appendChild(node('p', 'small', 'Currently sold out'));
    if (removable) { var remove = node('button', 'link', 'Remove'); remove.type = 'button'; remove.dataset.removeSaved = p.handle; remove.setAttribute('aria-label', 'Remove ' + p.title + ' from saved toys'); article.appendChild(remove); }
    return article;
  }
  var generation = 0;
  function renderSaved() {
    var dialog = d.getElementById('SavedToys'), grid = dialog.querySelector('[data-saved-grid]'), status = dialog.querySelector('[data-saved-status]');
    var handles = read(savedKey), version = ++generation;
    grid.replaceChildren(); dialog.querySelector('[data-clear-saved]').hidden = !handles.length;
    status.textContent = handles.length ? 'Checking your saved toys…' : 'A favourite starts with a little curiosity. Tap Save on any toy to keep it here.';
    // Four requests at a time, even when the saved list reaches its limit.
    var products = [], cursor = 0;
    function worker() { var index = cursor++; if (index >= handles.length) return Promise.resolve(); return fetchProduct(handles[index]).then(function (p) { products[index] = p; }, function () { products[index] = null; }).then(worker); }
    Promise.all([worker(), worker(), worker(), worker()]).then(function () {
      if (version !== generation) return;
      products.forEach(function (p, i) {
        if (p) grid.appendChild(card(p, true));
        else { var item = node('article', 'memory-card'); item.appendChild(node('p', '', 'This toy could not be loaded. Try again later.')); var remove = node('button', 'link', 'Remove saved toy'); remove.dataset.removeSaved = handles[i]; item.appendChild(remove); grid.appendChild(item); }
      });
      status.textContent = handles.length ? handles.length + ' saved ' + (handles.length === 1 ? 'toy' : 'toys') + '.' : status.textContent;
    });
  }
  d.addEventListener('click', function (e) {
    var save = e.target.closest('[data-save-toy]');
    if (save) {
      var h = save.dataset.saveToy; if (!valid(h)) return;
      var list = read(savedKey), index = list.indexOf(h);
      if (index < 0 && list.length >= 24) { announce('Your list has 24 toys. Remove one to make room.'); return; }
      if (index >= 0) list.splice(index, 1); else list.unshift(h);
      var persisted = write(savedKey, list); sync();
      announce(index >= 0 ? 'Removed from saved toys.' : persisted ? 'Saved for another little look.' : 'Saved for this page. Browser storage is unavailable.');
    }
    if (e.target.closest('[data-open-saved]')) { open(d.getElementById('SavedToys')); renderSaved(); }
    var remove = e.target.closest('[data-remove-saved]');
    if (remove) { write(savedKey, read(savedKey).filter(function (h) { return h !== remove.dataset.removeSaved; })); sync(); renderSaved(); d.querySelector('#SavedToys [data-dialog-close]').focus(); }
    if (e.target.closest('[data-clear-saved]')) { write(savedKey, []); sync(); renderSaved(); d.querySelector('#SavedToys [data-dialog-close]').focus(); }
    if (e.target.closest('[data-clear-recent]')) { write(recentKey, []); var recent = d.querySelector('[data-recent-toys]'); if (recent) recent.hidden = true; var main = d.getElementById('main'); if (main) main.focus(); announce('Recently viewed toys cleared.'); }
    var zoom = e.target.closest('[data-image-zoom]');
    if (zoom && typeof d.getElementById('ToyZoom').showModal === 'function') { e.preventDefault(); var image = d.querySelector('[data-zoom-image]'); image.src = zoom.href; image.alt = zoom.dataset.imageAlt || ''; open(d.getElementById('ToyZoom')); }
  });
  var product = d.querySelector('[data-product-handle]'), current = product && product.dataset.productHandle;
  var recent = read(recentKey).filter(function (h) { return h !== current; }).slice(0, 4);
  if (valid(current)) write(recentKey, [current].concat(read(recentKey).filter(function (h) { return h !== current; })).slice(0, 12));
  var recentBox = d.querySelector('[data-recent-toys]');
  if (recentBox && recent.length) {
    // Reserve nothing until at least one real product has returned; then defer images.
    Promise.all(recent.map(function (h) { return fetchProduct(h).catch(function () { return null; }); })).then(function (products) {
      if (!read(recentKey).length) return;
      var grid = recentBox.querySelector('[data-recent-grid]'); products.filter(Boolean).forEach(function (p) { grid.appendChild(card(p, false)); }); recentBox.hidden = !grid.children.length;
    });
  }
  function initFinders(scope) { all('[data-gift-finder]', scope).forEach(function (form) {
    if (form.dataset.finderReady) return; form.dataset.finderReady = 'true';
    var summary = form.querySelector('[data-finder-summary]'), base = form.action;
    function update() {
      var chosen = form.querySelector('[data-finder-age]:checked'), play = form.querySelector('[data-finder-play]:checked');
      // The age collection sets the boundary and the interest rides in the path (/collections/age-3-5/play-build):
      // Shopify filters tag paths natively, whereas filter.p.tag is ignored unless a tag filter is enabled in Search & Discovery.
      form.action = (chosen ? chosen.dataset.collection : base) + (play ? '/play-' + play.value : '');
      all('[data-finder-age]', form).forEach(function (input) { input.name = 'gift_age'; });
      var selected = all('input:checked', form).filter(function (input) { return input.value; }).map(function (input) { var label = form.querySelector('label[for="' + input.id + '"]'); return label ? label.textContent : ''; });
      if (summary) summary.textContent = selected.length ? 'Your gift search: ' + selected.join(' · ') : 'Choose an age, then follow their curiosity.';
    }
    form.addEventListener('formdata', function (e) { e.formData.delete('gift_age'); e.formData.delete('gift_play'); });
    form.addEventListener('change', update); form.addEventListener('reset', function () { setTimeout(update, 0); }); update();
  }); }
  window.addEventListener('storage', function (e) { if (e.key === savedKey) { delete memory[savedKey]; sync(); var dialog = d.getElementById('SavedToys'); if (dialog.open) renderSaved(); } });
  d.addEventListener('shopify:section:load', function (e) { initFinders(e.target); sync(); });
  d.addEventListener('products:loaded', sync); initFinders(); sync();
})();
